import Form from '../components/Form';
import 'form-serializer';
import FormValidate from './FormValidate';
import VanillaModal from 'vanilla-modal';

class FormOffer extends Form {
  setupDefaults() {
    super.setupDefaults();

    this.endpoint = this.$el.attr('action');
    this.step = 0;
    this.dom = {
      ...this.dom,
      $submitBtn: this.$el.find('input[type="submit"]'),
      $nextStepButton: this.$el.find('.form-offer__form-next-step')

    };

    if (this.$el.hasClass('js-open-modal')) {
      this.modal = new VanillaModal({
        onBeforeClose: () => {
          if (this.dom.$cta) window.location = this.dom.$cta.href;
        },
        clickOutside: true,
        'class': 'modal-open'
      });
    }

    if (this.$el.parents('.form-offer-ihc').length > 0) {
      this.$el.find('.callout-field--zip-code')[0].style.display = 'block';
    }
  }

  addListeners() {
    this.$el.on('submit', :: this.onOfferSubmit);
    this.dom.$nextStepButton.on('click', :: this.moveToStep);
  }

  onOfferSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    if (this.$el[0].checkValidity()) {
      this.submitOffer();
    }
  }

  async submitOffer() {
    this.dom.$submitBtn.attr('disabled', 'disabled').parent().addClass('is-loading');
    const res = await this.postOffer();

    if (res.success) {
      const data = this.$el.serializeJSON();
      window.dataLayer.push({
        event: 'formSubmit',
        formName: data.requestType,
        formId: data.MasterUniqueFormID
      });
      if (this.$el.hasClass('js-open-modal')) {
        this.onOpenModal()
      } else {
        const redirectURL = res.response.redirectUrl;
        window.location.replace(redirectURL);
      }
    } else {
      this.clearFormLevelError();
      if (this.dom.$nextStepButton !== null) {
        this.displayFormLevelErrorFourStep(res.message);
      } else {
        this.displayFormLevelError(res.message);
      }
      this.dom.$submitBtn.removeAttr('disabled').parent().removeClass('is-loading');
    }
  }

  postOffer() {
    const data = this.$el.serializeJSON();
    return $.ajax({
      method: 'POST',
      url: this.endpoint,
      contentType: 'application/json',
      data
    })
  }

  onOpenModal() {
    this.modal.open('#optional-prod-details-modal');
  }

  onCloseClick() {
    this.modal.close();
  }
  moveToStep() {
    const inputs = Array.from(this.$el.find('.form-offer__form .callout-field'));
    const elementsToValidate = this.$el.find('input:visible');
    let stepIsValid = true;

    $.each(elementsToValidate, (key, value) => {
      if (!value.checkValidity()) {
        stepIsValid = false;
        const formValidate = FormValidate();
        formValidate(
          value,
          value.getAttribute('data-msg-required')
        );
      }
    });
    if (stepIsValid) {

      // find element with a class of checkbox-form-emergency and update the display to none if it exists
      const emergencyCheckbox = this.$el.find('.form-emergency');
      if (emergencyCheckbox.length > 0) {
        console.log(emergencyCheckbox[0]);
        emergencyCheckbox[0].style.display = 'none';
      }


      inputs.forEach(e => { e.style.display = 'none'; });
      const formParent = this.$el.parents('.form-offer-ihc');
      switch (this.step) {
      case 0: //zip to contact info
        this.$el.find('.form-offer__form .callout-field--email')[0].style.display = 'block';
        this.$el.find('.form-offer__form .callout-field--phone-number')[0].style.display = 'block';
        this.step = 1;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-2');
        this.$el.find('.form-offer__form-next-step')[0].innerHTML = formParent.data('step-2Button');
        break;
      case 1:
        this.$el.find('.form-offer__form .callout-field--first-name')[0].style.display = 'block';
        this.$el.find('.form-offer__form .callout-field--last-name')[0].style.display = 'block';
        this.step = 2;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-3');
        this.$el.find('.form-offer__form-next-step')[0].innerHTML = formParent.data('step-3Button');
        break;
      case 2:
        this.$el.find('.form-offer__form .callout-field--services-required')[0].style.display = 'block';
        this.$el.find('.form-offer__form .callout-field--comments')[0].style.display = 'block';

        if (emergencyCheckbox.length > 0) {
          emergencyCheckbox[0].style.display = 'flex';
        }

        this.$el.find('.form-offer__form-submit')[0].style.display = 'block';
        this.$el.find('.form-offer__form-next-step')[0].style.display = 'none';
        this.step = 3;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-4');
        break;
      }
    }
  }
  displayFormLevelErrorFourStep(errorMessage) {
    let errorMessages = [];
    if (errorMessage.indexOf('~') !== -1) {
      errorMessages = errorMessage.split('~');
    } else {
      errorMessages.push(errorMessage);
    }
    if (typeof this.dom.$formLevelErrorContainer === 'undefined' || this.dom.$formLevelErrorContainer.length === 0) {
      const fourStepSubmitButton = this.$el.find('.form__submit.is-loading');
      $('<div class="form__global-error"></div>').insertBefore(fourStepSubmitButton);
      errorMessages.forEach(errorMsg => {
        this.dom.$formLevelErrorContainer = fourStepSubmitButton.prev('.form__global-error').append(`<p>${errorMsg}</p>`);
      });
    } else {
      errorMessages.forEach(errorMsg => {
        this.dom.$formLevelErrorContainer.append(`<p>${errorMsg}</p>`);
      });
    }
  }
}

export default FormOffer;



// WEBPACK FOOTER //
// ./src/lr/js/components/FormOffer.js